import {
  Paper,
  Grid2,
  Card,
  Typography,
  CardActionArea,
  Box,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState, useCallback } from "react";
import classes from "./css/products-list.module.css";
import * as services from "./../../services/saleng";
import toast, { Toaster } from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import ImageIcon from "@mui/icons-material/Image";
import WeightDialog from "../../components/CarScaleDialog";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import CancelIcon from "@mui/icons-material/Cancel";
// import CloseIcon from "@mui/icons-material/Close";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DescriptionIcon from "@mui/icons-material/Description";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import GroupsIcon from "@mui/icons-material/Groups";
import LockIcon from "@mui/icons-material/Lock";
import ChecklistIcon from "@mui/icons-material/Checklist";
import PaymentDialog from "./components/pay_dialog";
import ImageModal from "../../components/ImageModal";
import { formatNumber } from "./../../utils/formatNumber";
import { handleExportExcel } from "./components/generateReceivingForm";
import POSelectionDialog from "./components/POSelectionDialog";
import POBreakdownGrid from "./components/POBreakdownDialog";
import { green, yellow } from "@mui/material/colors";
import CustomerPickerDialog from "../../components/CustomerPickerDialog";
import ProductFormDialog from "./components/ProductFormDialog";
import Avatar from "@mui/material/Avatar";
import ItemTableModal from "../../components/ItemTableModal";
import Badge from "@mui/material/Badge";
import { getContrastColor } from "./../../utils/fontColor";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PrintIcon from "@mui/icons-material/Print";
import QRCode from "react-qr-code";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import "moment/locale/th";
const Page = ({ tabId, tabData }) => {
  const [cards, setCards] = useState([]);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState("ทุกประเภท");
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [imageDetail, setImageDetail] = useState([]);

  // dialogs
  const [openPOSelectionDialog, setOpenPOSelectionDialog] = useState(false);
  const [openTransactionDialog, setOpenTransactionDialog] = useState(false);
  const [openCustomerPickerDialog, setOpenCustomerPickerDialog] =
    useState(false);
  const [openPay, setOpenPay] = useState(false);
  const [openCarDialog, setOpenCarDialog] = useState(false);
  const [openImg, setOpenImg] = useState(false);
  const [openItemDialog, setOpenItemDialog] = useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);

  const [selectedValue, setSelectedValue] = useState([]);
  const [transaction, setTransaction] = useState(null);
  const [lockSelect, setLockSelect] = useState([]);

  const [note, setNote] = useState();
  const [isWeighed, setIsWeighed] = useState(true);

  const query = useQuery();
  const transactionId = query.get("id");
  const debounceTimer = useRef(null);

  const [poItems, setPoItems] = useState([]);
  const [poSelect, setPoSelect] = useState([]);
  const [lockItems, setLockItems] = useState([]);
  const [type, setType] = useState([]);

  const [transactionBreakdown, setTransactionBreakdown] = useState([]);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const handleConfirm = async (data) => {
    // สร้าง images เฉพาะถ้ามี imageUrl
    const imageUrl = data?.imageUrl;
    const images = imageUrl ? [{ imageUrl: imageUrl, type: "img" }] : [];

    let payload = {
      carHeavyWeight: parseFloat(data?.heavy || 0),
      carLightWeight: parseFloat(data?.light || 0),
      ...(images.length > 0 && { images }), // ส่งเฉพาะถ้ามี
    };

    await services.updateTransaction(payload, transactionId);
    fetchData();
    setOpenCarDialog(false);
  };

  const fetchData = useCallback(async () => {
    let cancelled = false;
    try {
      // เรียกพร้อมกัน เร็วกว่าเรียกทีละอัน
      const [productsRes, transactionRes, layoutRes] = await Promise.all([
        services.getProductsBranch(true),
        services.getTransaction(transactionId),
        services.getUserLayout(1), // เพิ่มเรียก layout ของผู้ใช้
      ]);

      if (cancelled) return;

      const products = productsRes?.data?.data ?? [];
      const layout = layoutRes?.data ?? [];

      // map productId เพื่อใช้กับ UI
      const productMap = {};
      products.forEach((item) => {
        productMap[item.id] = {
          ...item,
          productId: item.id,
          categoryName: item.category?.name ?? "ไม่ระบุ",
          color: item.subCategory?.color ?? "royalblue",
          code: item.code,
        };
      });

      const sortedCards = layout.length
        ? layout
            .filter((l) => l.box === "box1") // <-- เพิ่ม filter เฉพาะ box1
            .map((l) => productMap[l.productId])
            .filter(Boolean)
        : Object.values(productMap);

      const tx = transactionRes?.data?.data ?? {};

      setTransaction?.(tx);
      setIsWeighed?.(!!tx.isWeighed);
      setNote?.(tx.note ?? "");
      setPoSelect?.(
        tx.items?.flatMap((item) => item.purchaseOrderItems ?? []) ?? []
      );
      setLockSelect?.(tx.lockPricings ?? []);
      const categoryMap = products
        .map((p) => p?.category)
        .filter(Boolean)
        .reduce((acc, cur) => {
          if (!acc.some((c) => c.id === cur.id)) {
            acc.push(cur);
          }
          return acc;
        }, []);

      const sortedCategories = categoryMap.sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0)
      );

      const categories = sortedCategories.map((c) => c.name);
      setCategories?.(categories);
      if (categories.length > 0) {
        setFilter?.(categories[0]);
      }

      setCards?.(sortedCards); // เอา layout มาใช้แทน cards เดิม
      setData?.(sortedCards);
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    return () => {
      cancelled = true;
    };
  }, [transactionId]);

  // โหลด PO / Lock / data
  useEffect(() => {
    if (!transaction?.customerId || !transaction?.carId) return;
    const fetchPOs = async () => {
      try {
        const res = await services.getPurchaseOrders({
          customerId: transaction?.customerId,
          carId: transaction?.carId,
          currentDate: new Date().toISOString().split("T")[0],
        });
        setPoItems(res.data.data || []);
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการดึง PO:", error);
      }
    };

    const fetchLockPricing = async () => {
      try {
        const customerId = transaction?.customerId;
        const res = await services.getLockPricingByCustomer(customerId);
        const lockPricings = res.data;
        setLockItems(lockPricings);
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการดึง lock-pricing:", error);
      }
    };

    fetchPOs();
    fetchLockPricing();
  }, [fetchData, transaction?.carId, transaction?.customerId, transactionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // useEffect สำหรับคำนวณ breakdown และอัปเดต transaction
  useEffect(() => {
    if (!transaction?.items) return;

    const fetchDataAndCalculate = async () => {
      const breakdownList = [];
      const usedPOMap = new Map();
      const usedLockMap = new Map();

      transaction.items.forEach((item, index) => {
        const selectPOItems = (poSelect ?? []).flatMap(
          (po) => po.items ?? [po]
        );

        const itemsToUse =
          selectPOItems.length > 0 ? selectPOItems : selectPOItems;

        // Unique PO items
        const poItemsMap = new Map();
        itemsToUse.forEach((p) => poItemsMap.set(p.id, p));

        const preferIds = new Set(item.poItemIds || []);
        const matchingPOItems = Array.from(poItemsMap.values())
          .filter((poItem) => poItem.productId === item.productId)
          .sort((a, b) => {
            const aPrefer = preferIds.has(a.id) ? 1 : 0;
            const bPrefer = preferIds.has(b.id) ? 1 : 0;
            if (aPrefer !== bPrefer) return bPrefer - aPrefer;
            return new Date(a.createdAt || "") - new Date(b.createdAt || "");
          });

        const impurityWeight =
          (item.impurities || []).reduce((s, i) => s + (i.weight || 0), 0) +
          (item.deductedItems || []).reduce(
            (s, d) => s + (d.netWeight || 0),
            0
          );

        let remainingWeight = Math.max(
          0,
          (item.weight || 0) - (item.deductWeight || 0) - impurityWeight
        );
        const breakdown = [];

        // ใช้ LockPricing ก่อน
        const lockItemsForThisProduct = lockSelect.filter(
          (l) =>
            l.productId === item.productId &&
            l.customerId === transaction.customerId
        );

        lockItemsForThisProduct.forEach((lockItem) => {
          if (remainingWeight <= 0) return;

          const usedThisRun = usedLockMap.get(lockItem.id) || 0;

          const remainingFromDB = Math.max(
            0,
            (lockItem.lockWeight || 0) - (lockItem.actualWeight || 0)
          );
          console.log("remainingFromDB", remainingFromDB);
          const availableWeight = Math.max(0, remainingFromDB - usedThisRun);
          if (availableWeight <= 0) return;

          const weightToUse = Math.min(remainingWeight, availableWeight);

          breakdown.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: 0,
            poPricePerUnit: 0,
            totalPrice: weightToUse * (lockItem.purchasePrice || 0),
            usedWeight: weightToUse,
            priceSource: "lock",
            basePrice: item.product?.price,
            ...lockItem,
          });

          usedLockMap.set(lockItem.id, usedThisRun + weightToUse);
          remainingWeight -= weightToUse;
        });

        // ใช้ PO ถ้ายังเหลือ
        matchingPOItems.forEach((poItem) => {
          if (remainingWeight <= 0) return;

          const usedThisRun = usedPOMap.get(poItem.id) || 0;
          const alreadyUsed = poItem.actualWeight || 0;
          const availableWeight = poItem.unlimitedWeight
            ? Infinity
            : Math.max(0, (poItem.poWeight || 0) - (alreadyUsed + usedThisRun));
          if (availableWeight <= 0) return;

          const weightToUse = poItem.unlimitedWeight
            ? remainingWeight
            : Math.min(remainingWeight, availableWeight);

          breakdown.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: 0,
            poPricePerUnit: poItem.purchasePrice,
            totalPrice: weightToUse * (poItem.purchasePrice || 0),
            usedWeight: weightToUse,
            priceSource: "po",
            poInfo: { ...poItem },
            basePrice: item.product?.price,
          });

          usedPOMap.set(poItem.id, usedThisRun + weightToUse);
          remainingWeight -= weightToUse;
        });

        // 3️⃣ ราคากลุ่ม ถ้ายังเหลือ
        if (remainingWeight > 0) {
          breakdown.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: item.pricePerUnit,
            poPricePerUnit: 0,
            totalPrice: (item.pricePerUnit || 0) * remainingWeight,
            usedWeight: remainingWeight,
            priceSource: "group",
            isGroupAdjustment: true,
            basePrice: item.product?.price,
          });
        }

        breakdownList.push(...breakdown);
      });

      // Group breakdown
      const grouped = Object.values(
        breakdownList.reduce((acc, row) => {
          const key = row.index;
          const transactionItem = transaction.items[row.index];
          console.log("transaction", transaction);
          if (!acc[key]) {
            acc[key] = {
              basePrice: transactionItem.product.price,
              customerId: transaction.customerId,
              index: row.index,
              productId: row.productId,
              productName: row.productName,
              totalPrice: row.totalPrice,
              usedWeight: row.usedWeight || 0,
              sources: [row.priceSource],
              details: [row],
              originalItem: transactionItem
                ? {
                    ...transactionItem,
                    netWeight:
                      (transactionItem.weight || 0) -
                      (transactionItem.deductWeight || 0) -
                      ((transactionItem.impurities || []).reduce(
                        (s, i) => s + (i.weight || 0),
                        0
                      ) +
                        (transactionItem.deductedItems || []).reduce(
                          (s, d) => s + (d.netWeight || 0),
                          0
                        )),
                  }
                : {
                    id: null,
                    productName: row.productName,
                    productId: row.productId,
                    weight: 0,
                    netWeight: 0,
                    netPrice: row.totalPrice,
                  },
            };
          } else {
            acc[key].totalPrice += row.totalPrice;
            acc[key].usedWeight += row.usedWeight || 0;
            acc[key].sources.push(row.priceSource);
            acc[key].details.push(row);
          }
          return acc;
        }, {})
      );

      setTransactionBreakdown(grouped);

      // สร้าง payload
      const payloads = grouped
        .filter((g) => g.originalItem?.id)
        .map((g) => {
          const poItemsForThisItem = poSelect
            .flatMap((po) => (po.items ? po.items : [po]))
            .filter((p) => p.productId === g.originalItem.productId);

          const lockItemsForThisItem = lockSelect.filter(
            (l) =>
              l.productId === g.originalItem.productId &&
              l.customerId === transaction.customerId
          );

          const singlePO =
            poItemsForThisItem.length === 1 ? poItemsForThisItem[0] : null;
          const groupSource = g.details.find((d) => d.priceSource === "group");
          let pricePerUnit = g.originalItem.pricePerUnit;
          if (!(pricePerUnit > 0) && groupSource?.pricePerUnit != null)
            pricePerUnit = groupSource.pricePerUnit;

          return {
            id: g.originalItem.id,
            productId: g.originalItem.productId,
            productName: g.originalItem.productName,
            pricePerUnit: pricePerUnit || 0,
            weight: g.originalItem.weight || 0,
            deductWeight: g.originalItem.deductWeight || 0,
            netWeight: g.originalItem.netWeight || 0,
            netPrice: g.details.reduce(
              (sum, d) => sum + (d.totalPrice || 0),
              0
            ),
            poItemIds: poItemsForThisItem.map((p) => p.id),
            lockItemIds: lockItemsForThisItem.map((l) => l.id),
            poPricePerUnit: singlePO?.purchasePrice || null,
            usedWeight: singlePO?.usedWeight || null,
            isGroupAdjustment:
              poItemsForThisItem.length === 0 &&
              lockItemsForThisItem.length === 0,
          };
        });

      if (payloads.length > 0) {
        try {
          await services.updateTransaction({ items: payloads }, transactionId);
        } catch (err) {
          console.error("อัปเดต TransactionItem ไม่สำเร็จ:", err);
        }
      }
    };

    fetchDataAndCalculate();
  }, [transaction, poSelect, lockSelect, transactionId]);

  const handleChange = (event) => {
    const value = event.target.value;
    setFilter(value);

    if (value === "ทุกประเภท") {
      setCards(data);
    } else {
      const filteredProducts = data.filter((product) => {
        return product.category?.name === value;
      });
      setCards(filteredProducts);
    }
  };

  const handleSubmit = async (value) => {
    const {
      title,
      id: productId,
      weight,
      finalPrice,
      deduct,
      netWeight,
      impurities = [],
      itemId, // transactionItem.id (ถ้ามี = อัปเดต, ถ้าไม่มี = สร้าง)
      deductedItems = [],
      imageUrl,
      note,
    } = value;

    setOpenProductDialog(false);

    // --- parse ตัวเลขให้ชัด ---
    const _pricePerUnit = Number(finalPrice) || 0;
    const _weight = Number(weight) || 0;
    const _deductWeight = Number(deduct) || 0;
    const _netWeight = Number(netWeight) || 0;

    // น้ำหนักสิ่งเจือปนรวม
    const totalImpurityWeight = impurities.reduce((sum, it) => {
      const w = Number(it?.weight) || 0;
      return sum + w;
    }, 0);

    // สร้าง displayType "(a, b, c)"
    const types = impurities
      .map((it) => it?.type || "")
      .filter(Boolean)
      .join(", ");
    const displayType = `(${types})`;

    // ส่ง images เฉพาะเมื่อมี
    const images = imageUrl ? [{ imageUrl, type: "img" }] : [];

    // สร้าง payload หลัก (รายการหลัก)
    const mainItem = {
      id: itemId ?? undefined, // ถ้าไม่มี id = create, มี = update
      productName: title,
      productId: productId,
      pricePerUnit: _pricePerUnit,
      weight: _weight,
      deductWeight: _deductWeight,
      netWeight: _netWeight,
      netPrice: _netWeight * _pricePerUnit,
      note: note,
      impurityWeight: totalImpurityWeight,
      impurities: impurities.map((it) => ({
        ...it,
        weight: Number(it?.weight) || 0,
      })),
      impurityType: displayType,
      ...(images.length > 0 && { images }),
    };

    try {
      // อัปเดตรายการหลักก่อน
      const res = await services.updateTransaction(
        { items: [mainItem] },
        transactionId
      );

      const updatedMainItem = res?.data?.data?.items?.[0];
      if (!updatedMainItem?.id) {
        toast.error("ไม่สามารถอัปเดตรายการหลักได้");
        return;
      }

      // จากนั้นสร้าง/อัปเดตรายการหักแยก (ถ้ามี)
      const additionalItems = (deductedItems || []).map((it) => {
        const w = Number(it?.weight) || 0;
        const p = Number(it?.price) || 0;
        const addImages = imageUrl ? [{ imageUrl, type: "img" }] : [];
        return {
          sourceItemId: updatedMainItem.id, // ผูกกับแถวหลัก
          productName: it?.title,
          productId: Number(it?.id),
          pricePerUnit: _pricePerUnit,
          weight: w,
          deductWeight: 0,
          netWeight: w,
          netPrice: w * p,
          impurityWeight: 0,
          impurities: [],
          impurityType: "",
          usedWeight: null,
          ...(addImages.length > 0 && { images: addImages }),
        };
      });

      if (additionalItems.length > 0) {
        await services.updateTransaction(
          { items: additionalItems },
          transactionId
        );
      }

      toast.success(`บันทึกรายการ ${title} สำเร็จ`);
      setSelectedValue([]);
      await fetchData();
    } catch (err) {
      console.error("เกิดข้อผิดพลาดในการอัปเดต transaction:", err);
      toast.error("ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const handleUpdate = async (value) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: `ยืนยันการดำเนินการ`,
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data;
        if (value === "isWeighed") {
          data = {
            isWeighed: true,
          };
        } else if (value === "close") {
          data = {
            status: "close",
          };
        } else if (value === "waiting") {
          data = {
            status: "waiting",
          };
        } else {
          data = {
            status: "cancel",
          };
        }
        await services.updateTransaction(data, transactionId);
        toast.success(`บันทึกสำเร็จ`);
        fetchData();
      }
    });
  };

  const handleNoteChange = (e) => {
    const newNote = e.target.value;
    setNote(newNote);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      autoSaveNote(newNote);
    }, 1000);
  };

  const autoSaveNote = async (newNote) => {
    try {
      await services.updateTransaction({ note: newNote }, transactionId);
    } catch (err) {
      console.error("บันทึกหมายเหตุไม่สำเร็จ", err);
    }
  };

  const handleClose = async (value) => {
    setSelectedValue([]);
    setOpenProductDialog(false);
  };

  const handleDeleteItem = async (value) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: `ยืนยันที่จะลบ${value.productName} ?`,
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await services.deleteItemTransaction(transactionId, value.id);
        toast.success(`ลบรายการ ${value.productName} สำเร็จ`);
        fetchData();
      }
    });
  };
  const handleClick = (value) => {
    setOpenProductDialog(true);
    setSelectedValue(value);
  };

  const handleClickEdit = (value) => {
    console.log("value", value);
    setOpenProductDialog(true);
    const item = {
      categoryId: value?.product?.categoryId,
      itemId: value.id,
      title: value.productName,
      finalPrice: value.pricePerUnit,
      id: value.productId,
      weight: parseFloat(value.weight || 0),
      deduct: parseFloat(value.deductWeight || 0),
      netWeight: parseFloat(value.netWeight || 0),
      impurities: value.impurities,
      deductedItems: value.deductedItems,
      totalImpurityWeight: value.impurityWeight,
      note: value.note,
      value: value,
    };
    setSelectedValue(item);
  };

  const handleSelectMethod = async (method) => {
    try {
      console.log("transactionBreakdown", transactionBreakdown);

      const updates = {};
      const lockPricingCreates = [];
      const lockPricingUpdates = [];

      for (const tx of transactionBreakdown || []) {
        const originalCustomerId = tx.customerId;
        const purchasePrice = tx.basePrice;

        for (const d of tx.details || []) {
          const productId = d?.productId;
          const usedWeight = Number(d.usedWeight || 0);
          const predictPrice = d.predictPrice || usedWeight * purchasePrice;

          if (d?.priceSource === "po" && d?.poInfo?.id) {
            const id = d.poInfo.id;
            updates[id] = (updates[id] || 0) + usedWeight;
          }

          if (d?.priceSource === "group" && productId && originalCustomerId) {
            lockPricingCreates.push({
              productId,
              customerId: originalCustomerId,
              actualWeight: 0,
              purchasePrice,
              lockWeight: usedWeight,
              predictPrice,
              status: "OPEN",
            });
          }

          if (d?.priceSource === "lock" && productId && originalCustomerId) {
            lockPricingUpdates.push({
              productId,
              customerId: originalCustomerId,
              actualWeight: usedWeight,
            });
          }
        }
      }

      await Promise.all(
        Object.entries(updates).map(([id, actualWeight]) =>
          services.updatePurchaseOrderItemWeight(id, actualWeight)
        )
      );

      await Promise.all(
        lockPricingCreates.map((payload) => services.createLockPricing(payload))
      );

      await Promise.all(
        lockPricingUpdates.map((payload) =>
          services.updateLockPricing(
            payload.productId,
            payload.customerId,
            payload
          )
        )
      );
      await services.updateTransaction(
        {
          status: "payed",
          totalNetPrice: total.netPrice,
          totalWeight: total?.netWeight,
          paymentMethod: method,
        },
        transactionId
      );

      await fetchData();
      if (transaction.status !== "payed") {
        const promises = transaction.items.map((item) => {
          const payload = {
            productId: item.productId,
            quantity: item.netWeight,
            unitCost: item.pricePerUnit,
            transactionId: transaction.id,
            note: "รับสินค้าล็อตใหม่",
          };
          return services.updateStock(payload);
        });
        await Promise.all(promises);
      }
      handleExportExcel(transaction);
    } catch (e) {
      console.error("❌ update PO/LockPricing error:", e);
    }
  };

  const handleOpenPayment = async () => {
    if (poItems && poItems.length > 0 && (!poSelect || poSelect.length === 0)) {
      console.log("มีค่าใน poItems แต่ poSelect ไม่มีค่า");
      Swal.fire({
        title: "โปรดตรวจสอบอีกครั้ง",
        html: `
              <div style="background:#FFF3CD; padding:15px; border-radius:8px; text-align:left; color:#664D03; font-size:14px;">
       <div style="display:flex; align-items:center; gap:8px;">
          <div style="margin-top:2px;">
            <!-- WarningAmberIcon SVG -->
            <svg xmlns="http://www.w3.org/2000/svg" 
                 width="32" height="32" viewBox="0 0 24 24" 
                 fill="#664D03">
              <path d="M1 21h22L12 2 1 21z"/>
              <text x="12" y="17" text-anchor="middle" font-size="12" font-weight="bold" fill="#fff">!</text>
            </svg>
          </div>
          <div>
            พบใบเสนอราคาที่สามารถใช้กับบิลนี้ได้ <br/>
            กด <b>ยกเลิก</b> หากคุณต้องการกลับไปเลือกใบเสนอราคา <br/>
            กด <b>ทำรายการต่อไป</b> หากคุณต้องการจ่ายเงินโดยไม่ใช้ใบเสนอราคา
          </div>
        </div>
      </div>
    `,
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ทำรายการต่อไป",
        reverseButtons: true,
        confirmButtonColor: "#1E293B", // สีปุ่ม confirm
        cancelButtonColor: "#E0E0E0", // สีปุ่ม cancel
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("ผู้ใช้กด ทำรายการต่อไป");
          setOpenPay(true);
        }
      });
    } else {
      if (transaction.status === "payed") {
        handleSelectMethod("");
      } else {
        setOpenPay(true);
      }
    }
  };

  const [selectedImage, setSelectedImage] = useState([]);
  const [imageList, setImageList] = useState([]);

  const total = transactionBreakdown.reduce(
    (acc, item) => {
      const source = item.originalItem;
      const details = item.details || [];

      const impurityWeight =
        (item?.originalItem?.impurities || []).reduce(
          (sum, i) => sum + (i.weight ?? 0),
          0
        ) +
        (item?.originalItem?.deductedItems || []).reduce(
          (sum, d) => sum + (d.netWeight ?? 0),
          0
        );

      if (source) {
        acc.weight += source.weight || 0;
        acc.netWeight += source.netWeight || 0;
        acc.deductWeight += source.deductWeight || 0;
        acc.impurityWeight += impurityWeight;
        acc.netPrice += details.reduce(
          (sum, d) => sum + (d.totalPrice || 0),
          0
        );
      }

      return acc;
    },
    { netWeight: 0, netPrice: 0, deductWeight: 0, impurityWeight: 0, weight: 0 }
  );

  const handleChangeCustomer = async (customer) => {
    setOpenCustomerPickerDialog(false);

    const currentCustomerId = transaction.customerId;
    const newCustomerId = customer?.customer?.id;

    const payload = {
      customerId: newCustomerId,
      customerName: customer?.customer?.name,
      carId: customer?.car?.id,
      driverId: customer?.driver?.id,
    };

    await services.updateTransaction(payload, transactionId);

    if (currentCustomerId === newCustomerId) {
      await fetchData();
      return;
    }

    try {
      // เตรียมอัพเดตราคาใหม่ + ล้าง PO ของทุก item แบบ batch ในครั้งเดียว
      // ดึงราคากลุ่ม (basePrice + groupAdjustment) แบบ parallel
      const items = transaction?.items || [];

      const pricedItems = await Promise.all(
        items.map(async (item) => {
          try {
            const res = await services.getPriceProduct({
              customerId: newCustomerId,
              productId: item.productId,
            });
            const data = res?.data?.data || {};
            const newPrice =
              (data.basePrice ?? 0) + (data.groupAdjustment ?? 0);

            return {
              id: item.id,
              // ราคาใหม่ตามกลุ่มของซัพพลายเออร์ใหม่
              pricePerUnit: newPrice,
              // ล้าง PO ที่เคยผูกไว้กับ item นี้
              poId: null,
              usedWeight: null,
              poPricePerUnit: null,
            };
          } catch (e) {
            console.error("getPriceProduct failed for item", item.id, e);
            // ถ้าดึงราคาไม่สำเร็จ ก็ยังล้าง PO ออก แต่คงราคาเดิมไว้
            return {
              id: item.id,
              pricePerUnit: item.pricePerUnit ?? 0,
              poId: null,
              usedWeight: null,
              poPricePerUnit: null,
            };
          }
        })
      );

      // updateTransaction ครั้งเดียวด้วย items ทั้งชุด
      await services.updateTransaction({ items: pricedItems }, transactionId);

      // เคลียร์ state PO ที่เลือกไว้ (กันงง)
      setPoSelect([]);

      toast.success("เปลี่ยนซัพพลายเออร์ + ล้าง PO ของรายการทั้งหมดเรียบร้อย");
      await fetchData();
    } catch (err) {
      console.error("Error handleChangeCustomer:", err);
      toast.error("อัปเดตราคา/ล้าง PO ไม่สำเร็จ");
    }
  };
  const [show_qrcode, setShowQrCode] = useState(false);
  const printRef = useRef();
  const style_assign = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    bgcolor: "background.paper",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(`
            <html>
            <head>
                <style>
                    @page {
                        size: 100mm 150mm;
                        margin: 0;
                    }
                    body {
                        margin: 0;
                        font-family: 'Arial', sans-serif;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100%;
                    }
                    .print-area {
                        width: 100mm;
                        height: 150mm;
                        padding: 10mm;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: flex-start;
                        text-align: left;
                    }
                    .qr {
                        margin-bottom: 12px;
                    }
                    b {
                        font-weight: bold;
                    }
                    p {
                        margin: 2px 0;
                        font-size: 14px;
                    }
                </style>
            </head>
            <body>
                <div class="print-area">
                    ${printContents}
                </div>
            </body>
            </html>
        `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const showQrcode = async () => {
    setShowQrCode(true);
  };

  return (
    <Box p={2}>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Modal
        open={show_qrcode}
        onClose={() => setShowQrCode(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ zIndex: 2 }}
      >
        <Box sx={style_assign}>
          <IconButton
            style={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setShowQrCode(false)}
          >
            <CloseIcon />
          </IconButton>
          {/* QR Code */}
          <Box ref={printRef}>
            <Box display="flex" justifyContent="center" mb={2}>
              <QRCode
                value={
                  "Batch No. :" +
                  transaction?.TransactionBatch[0]?.batch?.batchNumberr +
                  "\nReceive Date" +
                  moment(
                    transaction?.TransactionBatch[0]?.batch?.createdAt
                  ).format("DD-MM-YYYY")
                }
              />
            </Box>
            {/* รายละเอียด */}
            <Typography>
              <b>Batch No. :</b>{" "}
              {transaction?.TransactionBatch[0]?.batch?.batchNumber}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#f2f2f2",
                color: "#000",
                fontWeight: "bold",
                borderRadius: "12px",
                px: 4,
              }}
              onClick={handlePrint}
            >
              Print QR CODE
            </Button>
          </Box>
        </Box>
      </Modal>
      <AppBreadcrumbs />

      <Box my={2}>
        <Grid2 container spacing={0.5}>
          <Grid2 size={5}>
            <Paper
              className={classes["products-container"]}
              elevation={5}
              square
              style={{
                display: "flex",
                flexDirection: "column",
                height: "80vh",
              }}
            >
              {/* ส่วนหัว */}
              {transaction && (
                <>
                  <Box sx={{ mb: 2, padding: 0 }}>
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        backgroundColor: "#e0f7fa",
                        borderRadius: "4px",
                      }}
                    >
                      {/* ชื่อซัพพลายเออร์ */}
                      <Box display="flex" alignItems="center">
                        <Box
                          flex={1}
                          sx={{
                            cursor: "pointer",
                            "&:hover": {
                              bgcolor: "grey.100",
                            },
                          }}
                          onClick={() => setOpenCustomerPickerDialog(true)}
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            p={1.5}
                          >
                            {/* ชื่อ + รถ */}
                            <Box display="flex" gap={1} alignItems="center">
                              {/* กลุ่ม */}
                              {transaction.customer?.customerGroup
                                ?.name?.[0] && (
                                <Avatar>
                                  {
                                    transaction.customer?.customerGroup
                                      ?.name?.[0]
                                  }
                                </Avatar>
                              )}
                              {/* ชื่อ */}
                              <Typography>
                                <strong>
                                  ชื่อ : {transaction?.customerName}
                                </strong>
                              </Typography>
                              {/* รถ */}
                              <Typography>
                                {transaction?.car?.type
                                  ? `${transaction.car.type} - `
                                  : ""}
                                {transaction?.car?.license
                                  ? `${transaction.car.license}`
                                  : ""}{" "}
                                {transaction?.car?.province
                                  ? `(${transaction.car.province})`
                                  : ""}
                              </Typography>
                              {/* <Typography>
                              {transaction?.driver?.name
                                ? `${transaction.driver.name}`
                                : ""}{" "}
                              {transaction?.driver?.surname
                                ? `${transaction.driver.surname}`
                                : ""}
                            </Typography> */}
                            </Box>
                            <Box>
                              <EditIcon />
                            </Box>
                          </Box>
                        </Box>

                        {/* icons */}
                        <Box>
                          <IconButton
                            onClick={() => setOpenPOSelectionDialog(true)}
                          >
                            <DocumentScannerIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}

              {/* กล่องแสดง mockItems */}
              <Box
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  minHeight: 0,
                }}
              >
                {transactionBreakdown?.length ? (
                  transactionBreakdown
                    .filter(
                      (item) =>
                        item.originalItem && item.originalItem.id != null
                    )
                    .map((item, index) => {
                      return (
                        <Paper key={index} variant="outlined" sx={{ mb: 1 }}>
                          <Box>
                            <Box display="flex" justifyContent="space-between">
                              {/* รายการสินค้า */}
                              <Box
                                flex={1}
                                p={2}
                                sx={{
                                  cursor:
                                    transaction.status === "payed"
                                      ? "not-allowed"
                                      : "pointer",
                                  pointerEvents:
                                    transaction.status === "payed"
                                      ? "none"
                                      : "auto", // ปิดการคลิก
                                  opacity:
                                    transaction.status === "payed" ? 0.9 : 1, // ทำให้ดูจางลง
                                  "&:hover": {
                                    bgcolor:
                                      transaction.status === "payed"
                                        ? "transparent"
                                        : "grey.100",
                                  },
                                }}
                                onClick={() =>
                                  handleClickEdit(item?.originalItem)
                                }
                              >
                                {/* ชื่อสินค้า + ราคาสินค้า */}
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  {/* ชื่อสินค้า */}
                                  <Box
                                    display="flex"
                                    flexDirection="column"
                                    gap={1}
                                  >
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      gap={1}
                                    >
                                      <Typography
                                        variant="subtitle1"
                                        sx={{
                                          fontSize: 18,
                                          fontWeight: "bold",
                                          flexShrink: 1,
                                        }}
                                      >
                                        {index + 1}. {item?.productName}
                                      </Typography>
                                      <EditIcon fontSize="small" />
                                    </Box>

                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      gap={1}
                                    >
                                      <Typography
                                        variant="subtitle1"
                                        sx={{
                                          fontSize: 18,
                                          fontWeight: "bold",
                                          flexShrink: 1,
                                        }}
                                      >
                                        SKU:{item?.originalItem?.product.code}
                                      </Typography>
                                    </Box>
                                  </Box>

                                  {/* ราคาสินค้า */}
                                  <Box display="flex" gap={1}>
                                    {item?.details?.length > 1 &&
                                      (() => {
                                        const basePrice =
                                          item.originalItem.product.price;
                                        const totalPrice = item.totalPrice;
                                        const usedWeight = item.usedWeight;
                                        const average = totalPrice / usedWeight;
                                        const diff = average - basePrice;
                                        return (
                                          <Box
                                            /* key={index}  // ใช้ key ต่อเมื่ออยู่ใน .map เท่านั้น */
                                            display="flex"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                          >
                                            <Box
                                              display="flex"
                                              sx={{
                                                position: "relative",
                                                bgcolor: green[100],
                                                borderRadius: 1,
                                                gap: 1,
                                                px: 1,
                                                alignItems: "center",
                                              }}
                                            >
                                              {/* Badge ส่วนต่าง */}
                                              {diff !== 0 && (
                                                <Box
                                                  sx={{
                                                    position: "absolute",
                                                    top: -15,
                                                    right: -15,
                                                    bgcolor:
                                                      diff > 0
                                                        ? "success.main"
                                                        : "error.main",
                                                    color: "white",
                                                    px: 1,
                                                    fontSize: 12,
                                                    fontWeight: "bold",
                                                    borderRadius: 1,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  {diff > 0
                                                    ? `+${formatNumber(diff)}`
                                                    : `-${formatNumber(Math.abs(diff))}`}
                                                </Box>
                                              )}

                                              {/* ไอคอน */}
                                              <DocumentScannerIcon fontSize="small" />

                                              {/* ข้อความ */}
                                              <Typography>
                                                {formatNumber(average)} บาท/กก.
                                              </Typography>
                                            </Box>
                                          </Box>
                                        );
                                      })()}

                                    {item?.details?.length === 1 &&
                                      item.details.map((detail, index) => {
                                        const basePrice = detail.basePrice ?? 0;
                                        const currentPrice =
                                          detail.priceSource === "po"
                                            ? detail.poPricePerUnit
                                            : detail.priceSource === "lock"
                                              ? detail.purchasePrice
                                              : detail.pricePerUnit;

                                        const diff = currentPrice - basePrice;
                                        return (
                                          <Box
                                            key={index}
                                            display="flex"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                          >
                                            <Box
                                              display="flex"
                                              sx={{
                                                position: "relative",
                                                bgcolor: green[100],
                                                borderRadius: 1,
                                                gap: 1,
                                                px: 1,
                                                alignItems: "center",
                                              }}
                                            >
                                              {/* Badge ส่วนต่าง */}
                                              {diff !== 0 && (
                                                <Box
                                                  sx={{
                                                    position: "absolute",
                                                    top: -15,
                                                    right: -15,
                                                    bgcolor:
                                                      diff > 0
                                                        ? "success.main"
                                                        : "error.main",
                                                    color: "white",
                                                    px: 1,
                                                    fontSize: 12,
                                                    fontWeight: "bold",
                                                    borderRadius: 1,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  {diff > 0
                                                    ? `+${formatNumber(diff)}`
                                                    : `-${formatNumber(Math.abs(diff))}`}
                                                </Box>
                                              )}
                                              {/* ไอคอน */}
                                              {detail.priceSource ===
                                              "group" ? (
                                                detail.isGroupAdjustment ? (
                                                  <GroupsIcon fontSize="small" />
                                                ) : (
                                                  <LockIcon fontSize="small" />
                                                )
                                              ) : (
                                                <DocumentScannerIcon fontSize="small" />
                                              )}
                                              {/* ข้อความ */}
                                              <Typography>
                                                {detail.priceSource === "po"
                                                  ? formatNumber(
                                                      detail.poPricePerUnit
                                                    )
                                                  : detail.priceSource ===
                                                      "lock"
                                                    ? formatNumber(
                                                        detail.purchasePrice
                                                      )
                                                    : formatNumber(
                                                        detail.pricePerUnit
                                                      )}{" "}
                                                บาท/กก.
                                              </Typography>
                                            </Box>
                                          </Box>
                                        );
                                      })}
                                  </Box>
                                </Box>

                                {/* รายละเอียดน้ำหนัก */}
                                <Box display="flex" mt={1} gap={2}>
                                  <Typography>
                                    รวมน้ำหนัก:{" "}
                                    {formatNumber(item?.originalItem?.weight)}
                                  </Typography>
                                  <Typography>
                                    {" "}
                                    หัก:{" "}
                                    {formatNumber(
                                      item?.originalItem?.deductWeight
                                    )}
                                  </Typography>
                                  <Typography>
                                    {" "}
                                    สิ่งเจือปน:{" "}
                                    {formatNumber(
                                      item?.originalItem?.impurityWeight
                                    )}
                                  </Typography>
                                  <Typography>
                                    {" "}
                                    ={" "}
                                    {formatNumber(
                                      item?.originalItem?.netWeight
                                    )}
                                  </Typography>
                                </Box>

                                <Box display="flex" justifyContent="flex-end">
                                  <Typography>
                                    <strong>
                                      {formatNumber(item.totalPrice)}
                                    </strong>{" "}
                                    บาท
                                  </Typography>
                                </Box>

                                <Box>
                                  <Box>
                                    {[
                                      ...(
                                        item?.originalItem?.impurities || []
                                      ).map((i) => i.type),
                                      ...(item?.originalItem?.deductedItems
                                        ?.length
                                        ? item?.originalItem?.deductedItems.map(
                                            (d) =>
                                              `หักเป็น${d.productName || ""}`
                                          )
                                        : []),
                                    ].filter(Boolean).length > 0 && (
                                      <Typography>
                                        <strong>สิ่งเจือปน</strong>{" "}
                                        {[
                                          ...(
                                            item?.originalItem?.impurities || []
                                          ).map((i) => i.type),
                                          ...(item?.originalItem?.deductedItems
                                            ?.length
                                            ? item?.originalItem?.deductedItems.map(
                                                (d) =>
                                                  `หักเป็น${d.productName || ""}`
                                              )
                                            : []),
                                        ]
                                          .filter(Boolean)
                                          .join(", ")}
                                      </Typography>
                                    )}
                                  </Box>

                                  {item?.originalItem?.note && (
                                    <Box mt={1}>
                                      <Typography>
                                        <DescriptionIcon />{" "}
                                        {item?.originalItem?.note}
                                      </Typography>
                                    </Box>
                                  )}
                                  <Box mt={1}>
                                    {item?.originalItem?.sourceItem && (
                                      <Typography>
                                        <DescriptionIcon /> หักเป็นสินค้าอื่น
                                        จาก{" "}
                                        {
                                          item?.originalItem?.sourceItem
                                            ?.productName
                                        }
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box mt={1} display={"flex"} gap={1}>
                                    <Box>
                                      {item.details.some(
                                        (d) => d.priceSource === "po"
                                      ) && (
                                        <Typography>
                                          <strong>สินค้านี้ใช้ราคา</strong> PO
                                          {item.details
                                            .filter(
                                              (d) => d.priceSource === "po"
                                            )
                                            .map(
                                              (d) =>
                                                ` #${d.poInfo?.purchaseOrderId}`
                                            )
                                            .filter(Boolean)
                                            .join(", ")}
                                        </Typography>
                                      )}

                                      {item.details.some(
                                        (d) => d.priceSource === "lock"
                                      ) && (
                                        <Typography>
                                          <strong>
                                            สินค้านี้ใช้ล็อคราคารายวัน
                                          </strong>
                                        </Typography>
                                      )}
                                    </Box>

                                    <Box>
                                      {item.details.some(
                                        (d) => d.priceSource === "po"
                                      ) &&
                                        item.details.some(
                                          (d) => d.priceSource === "group"
                                        ) && (
                                          <Typography
                                            variant="body2"
                                            color={yellow[700]}
                                          >
                                            <strong>
                                              (ส่วนเกิน{" "}
                                              {item.details
                                                .filter(
                                                  (d) =>
                                                    d.priceSource === "group"
                                                )
                                                .reduce(
                                                  (sum, d) =>
                                                    formatNumber(
                                                      sum + d.usedWeight
                                                    ),
                                                  0
                                                )}{" "}
                                              ราคากลุ่ม)
                                            </strong>
                                          </Typography>
                                        )}

                                      {item.details.some(
                                        (d) => d.priceSource === "lock"
                                      ) &&
                                        item.details.some(
                                          (d) => d.priceSource === "group"
                                        ) && (
                                          <Typography
                                            variant="body2"
                                            color={yellow[700]}
                                          >
                                            <strong>
                                              (ส่วนเกิน{" "}
                                              {item.details
                                                .filter(
                                                  (d) =>
                                                    d.priceSource === "group"
                                                )
                                                .reduce(
                                                  (sum, d) =>
                                                    formatNumber(
                                                      sum + d.usedWeight
                                                    ),
                                                  0
                                                )}{" "}
                                              ราคากลุ่ม)
                                            </strong>
                                          </Typography>
                                        )}
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>

                              {/* icons */}
                              <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="space-around"
                                pr={1}
                              >
                                {/* ลบ */}
                                <IconButton
                                  color="error"
                                  disabled={transaction.status === "payed"}
                                  onClick={() =>
                                    handleDeleteItem(item.originalItem)
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>

                                {/* รูป */}
                                <Badge
                                  badgeContent={
                                    item?.originalItem?.images.length || 0
                                  }
                                  color="error"
                                  overlap="circular"
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                  sx={{
                                    "& .MuiBadge-badge": {
                                      right: 4,
                                      top: 4,
                                      fontWeight: 700,
                                    },
                                  }}
                                >
                                  <IconButton
                                    onClick={() => {
                                      setSelectedImage([
                                        item?.originalItem?.images[
                                          item?.originalItem?.images.length - 1
                                        ],
                                      ]);
                                      setImageList(item?.originalItem?.images);
                                      setImageDetail(item?.originalItem);
                                      setOpenImg(true);
                                      setType("item");
                                    }}
                                    disabled={
                                      !item?.originalItem?.images[
                                        item?.originalItem?.images.length - 1
                                      ]
                                    }
                                  >
                                    <ImageIcon />
                                  </IconButton>
                                </Badge>

                                {/* รายการ */}
                                {item?.sources.includes("po") && (
                                  <Badge
                                    badgeContent={item?.details?.length || 0}
                                    color="error"
                                    overlap="circular"
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "right",
                                    }}
                                    sx={{
                                      "& .MuiBadge-badge": {
                                        right: 4,
                                        top: 4,
                                        fontWeight: 700,
                                      },
                                    }}
                                  >
                                    <IconButton
                                      onClick={() => {
                                        setSelectedItem(item);
                                        setOpenItemDialog(true);
                                      }}
                                      aria-label="เปิดรายละเอียดรายการ"
                                    >
                                      <ChecklistIcon />
                                    </IconButton>
                                  </Badge>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Paper>
                      );
                    })
                ) : (
                  <Typography
                    variant="subtitle1"
                    sx={{
                      width: "100%",
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    ไม่มีรายการ
                  </Typography>
                )}
              </Box>

              {/* Footer */}
              <Box
                sx={{
                  borderTop: "1px solid #ccc",
                }}
                pt={2}
              >
                <Paper variant="outlined">
                  {/* น้ำหนักรถขนส่ง */}
                  <Box display="flex">
                    {/* ช่องน้ำหนักรถ */}
                    <Box
                      flex={1}
                      pr={10}
                      p={2}
                      onClick={() => setOpenCarDialog(true)}
                      sx={{
                        cursor:
                          transaction?.status === "payed"
                            ? "not-allowed"
                            : "pointer",
                        pointerEvents:
                          transaction?.status === "payed" ? "none" : "auto", // ปิดการคลิก
                        opacity: transaction?.status === "payed" ? 0.9 : 1, // ทำให้ดูจางลง
                        "&:hover": {
                          bgcolor:
                            transaction?.status === "payed"
                              ? "transparent"
                              : "grey.100",
                        },
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <Typography variant="h6">น้ำหนักรถขนส่ง</Typography>
                        <EditIcon fontSize="small" />
                      </Box>
                      <Box display="flex" gap={4}>
                        {/* รถหนัก */}
                        <Box display="flex" gap={1}>
                          <Typography>รถหนัก: </Typography>
                          <Typography>
                            {formatNumber(transaction?.carHeavyWeight)}
                          </Typography>
                        </Box>
                        {/* รถเบา */}
                        <Box display="flex" gap={1}>
                          <Typography>รถเบา:</Typography>
                          <Typography>
                            {formatNumber(transaction?.carLightWeight)}
                          </Typography>
                        </Box>
                        {/* รวม */}
                        <Box display="flex" gap={1}>
                          <Typography>
                            ={" "}
                            {formatNumber(
                              transaction?.carHeavyWeight -
                                transaction?.carLightWeight
                            )}{" "}
                            กก.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* ช่องรูปภาพ รถ */}
                    <Box pr={1}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-around"
                        gap={1}
                      >
                        <Badge
                          badgeContent={transaction?.images.length || 0}
                          color="error"
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 4,
                              top: 4,
                              fontWeight: 700,
                            },
                          }}
                        >
                          <IconButton
                            onClick={() => {
                              setSelectedImage([
                                transaction?.images[
                                  transaction?.images.length - 1
                                ],
                              ]);
                              setImageDetail({
                                carHeavyWeight: transaction?.carHeavyWeight,
                                carLightWeight: transaction?.carLightWeight,
                                images: transaction?.images,
                              });
                              setImageList(transaction?.images);
                              setType("car");
                              setOpenImg(true);
                            }}
                            disabled={
                              !transaction?.images[
                                transaction?.images.length - 1
                              ]
                            }
                          >
                            <ImageIcon />
                          </IconButton>
                        </Badge>
                        <IconButton
                          onClick={() => setOpenTransactionDialog(true)}
                        >
                          <ChecklistIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>

                  <Divider />

                  {/* น้ำหนักสุทธิ */}
                  <Box p={1}>
                    <Box p={1}>
                      {/* น้ำหนักรวม */}
                      <Box display="flex" justifyContent="space-between" mb={1}>
                        <Typography>
                          น้ำหนักสุทธิ{" "}
                          <strong>{formatNumber(total.netWeight)}</strong> กก.
                        </Typography>
                        <Typography>
                          น้ำหนักรถ{" "}
                          <strong>
                            {formatNumber(
                              transaction?.carHeavyWeight -
                                transaction?.carLightWeight
                            )}
                          </strong>{" "}
                          กก.
                        </Typography>
                      </Box>

                      {/* รายละเอียด */}
                      <Box display="flex" gap={5}>
                        <Typography>
                          รวม: {formatNumber(total?.weight)}
                        </Typography>
                        <Typography>
                          หัก: {formatNumber(total?.deductWeight)}
                        </Typography>
                        <Typography>
                          สิ่งเจือปน: {formatNumber(total?.impurityWeight)}
                        </Typography>
                        <Typography>
                          = {formatNumber(total?.netWeight)}
                        </Typography>
                      </Box>

                      {/* แจ้งเตือนถ้าไม่อยู่ในช่วง ±0.9% ของ 1100 */}
                      {total?.weight &&
                        (total?.weight <= 1090.1 ||
                          total?.weight >= 1109.9) && (
                          <Typography color="error" fontWeight="bold" mt={1}>
                            ⚠️ น้ำหนักรวมไม่อยู่ในช่วง ±0.9% ของ 1100
                          </Typography>
                        )}
                    </Box>
                  </Box>
                </Paper>
                <Box className={classes["title-container"]} sx={{ mt: 2 }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      gap: "0.5rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>ยอดก่อนรวมภาษี:</p>
                      <p>
                        {formatNumber(total.netPrice)}
                        {"บาท"}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>ภาษีมูลค่าเพิ่ม 7%:</p>
                      <p>0.00 {" บาท"}</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="h6" color="primary">
                        ยอดสุทธิ:
                      </Typography>{" "}
                      <b>
                        <Typography variant="h6" color="primary">
                          <strong>{formatNumber(total.netPrice)}</strong>
                        </Typography>
                      </b>
                    </div>
                  </div>
                </Box>
              </Box>
            </Paper>
          </Grid2>
          <Grid2 size={1.6}>
            <Paper
              className={classes["products-container"]}
              elevation={5}
              square
              style={{
                display: "flex",
                flexDirection: "column",
                height: "80vh",
              }}
            >
              <Box
                sx={{
                  // width: 180,
                  flexShrink: 0,
                  backgroundColor: "#fff",
                  overflowY: "auto",
                  paddingRight: 1,
                  boxSizing: "border-box",
                }}
              >
                <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
                  หมวดหมู่
                </Typography>

                {categories.map((name, index) => (
                  <Button
                    key={index}
                    variant={filter === name ? "contained" : "outlined"}
                    fullWidth
                    sx={{ mb: 1, height: 64, fontSize: 18 }}
                    onClick={() => handleChange({ target: { value: name } })}
                  >
                    {name}
                  </Button>
                ))}
              </Box>
            </Paper>
          </Grid2>

          <Grid2 size={5.4}>
            <Paper
              className={classes["products-container"]}
              elevation={5}
              square
              style={{
                display: "flex",
                flexDirection: "column",
                height: "80vh",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                  p: 1,
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: 1,
                  }}
                >
                  {cards
                    .filter((card) =>
                      filter === "ทุกประเภท"
                        ? true
                        : card.categoryName === filter
                    )
                    .map((card) => (
                      <Card
                        key={card.productId}
                        sx={{
                          height: 100,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          p: 0,
                          m: 0,
                          overflow: "hidden",
                        }}
                      >
                        <CardActionArea
                          onClick={() => handleClick(card)}
                          disabled={card?.status === "payed"}
                          sx={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: card?.color ?? "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0.5,
                            opacity: card?.status === "payed" ? 0.5 : 1,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textAlign: "center",
                              width: "100%",
                              color: getContrastColor(card?.color ?? "#ffffff"),
                            }}
                          >
                            {card.title} {card.code}
                          </Typography>
                        </CardActionArea>
                      </Card>
                    ))}
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "1rem",
                  borderTop: "1px solid #ccc",
                  backgroundColor: "#fff",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  {/* ปุ่มฝั่งซ้าย */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      width: "40%",
                      mr: 1,
                    }}
                  >
                    <TextField
                      label="หมายเหตุ"
                      multiline
                      rows={5}
                      variant="outlined"
                      fullWidth
                      value={note || ""}
                      onChange={handleNoteChange}
                      InputLabelProps={{ shrink: true }}
                      disabled={transaction?.status === "cancel"}
                    />
                  </Box>
                  {/* ปุ่มฝั่งขวา */}
                  <Box sx={{ width: "70%" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "8px",
                        gap: "1rem",
                      }}
                    >
                      <Button
                        sx={{ height: "5rem", flex: 1 }}
                        variant="contained"
                        color="primary"
                        startIcon={<InsertDriveFileIcon />}
                        onClick={() => {
                          // เช็คเงื่อนไขก่อนจ่าย
                          if (
                            total?.weight <= 1090.1 ||
                            total?.weight >= 1109.9
                          ) {
                            alert(
                              "⚠️ น้ำหนักรวมไม่อยู่ในช่วง ±0.9% ของ 1,100 รายการจะไม่ถุกสร้าง Batch อัตโนมัติ"
                            );
                          }

                          handleOpenPayment();
                        }}
                        disabled={transaction?.status === "cancel"}
                      >
                        {transaction?.status !== "payed"
                          ? "จ่าย"
                          : "ปริ้น แบบฟอร์มรับสินค้าเข้า"}
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "1rem",
                      }}
                    >
                      {transaction?.status !== "payed" && (
                        <Button
                          sx={{ height: "4rem", flex: 1 }}
                          variant="contained"
                          startIcon={<CancelIcon />}
                          color="error"
                          onClick={() =>
                            handleUpdate(
                              transaction?.status === "waiting"
                                ? "cancle"
                                : "waiting"
                            )
                          }
                          disabled={transaction?.status === "cancel"}
                        >
                          {transaction?.status === "waiting"
                            ? "ยกเลิกBatch"
                            : "ยกเลิก"}
                        </Button>
                      )}
                      {/* แสดงปุ่มพิเศษเมื่อจ่ายแล้ว */}
                      {transaction?.status === "payed" && (
                        <Button
                          sx={{ height: "4rem", flex: 1 }}
                          variant="contained"
                          color="success"
                          onClick={() => showQrcode()}
                          startIcon={<QrCodeIcon />}
                        >
                          ปริ้น QRCODE Batch
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Grid2>
        </Grid2>
      </Box>

      <POSelectionDialog
        open={openPOSelectionDialog}
        onClose={() => setOpenPOSelectionDialog(false)}
        transaction={transaction}
        poSelect={poSelect}
        setPoSelect={setPoSelect}
        lockSelect={lockSelect}
        setLockSelect={setLockSelect}
        poItems={poItems}
        lockItems={lockItems}
      />

      <POBreakdownGrid
        open={openTransactionDialog}
        onClose={() => setOpenTransactionDialog(false)}
        poData={transactionBreakdown}
      />

      <CustomerPickerDialog
        open={openCustomerPickerDialog}
        onClose={() => setOpenCustomerPickerDialog(false)}
        showCreateButton
        onSuccess={handleChangeCustomer}
      />

      <ImageModal
        open={openImg}
        onClose={() => setOpenImg(false)}
        imageDetail={imageDetail}
        selectedImage={selectedImage}
        type={type}
      />

      <ProductFormDialog
        selectedValue={selectedValue}
        transaction={transaction}
        customer={transaction?.customer}
        open={openProductDialog}
        onClose={handleClose}
        onSubmit={handleSubmit}
      />

      <WeightDialog
        transaction={transaction}
        open={openCarDialog}
        onClose={() => setOpenCarDialog(false)}
        onConfirm={handleConfirm}
      />

      <PaymentDialog
        open={openPay}
        onClose={() => setOpenPay(false)}
        onSelect={handleSelectMethod}
      />

      <ItemTableModal
        open={openItemDialog}
        onClose={() => {
          setOpenItemDialog(false);
          setSelectedItem(null);
        }}
        item={selectedItem}
      />
    </Box>
  );
};

export default Page;
